import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Spinner,
  Text,
  Box,
  Badge,
  Divider,
  HStack,
  VStack,
  IconButton,
  Checkbox,
  Th,
  Thead,
  Table,
  Td,
  Tbody,
  Tr,
  Textarea,
  Link,
} from "@chakra-ui/react";
import { showToast } from "components/toast/Toast";
import useApi from "hooks/useApi";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  RepeatIcon,
} from "@chakra-ui/icons";
import { PROPERTY_COLLECTIONS } from "constants/dbEnums";
import { metersToKm } from "constants/commonFunctions";
import { formatDate } from "constants/commonFunctions";
import { shareToWhatsApp } from "utils/shareToWhatsApp";
import { GET_RECOMMENDED_PROPERTIES } from "constants/endpoints";
import SelectInput from "components/addForm/SelectInput";
import { SHARE_RECOMMENDED_PROPERTIES } from "constants/endpoints";
import { whatsappMessageFormat } from "utils/shareToWhatsApp";
import { PROPERTY_TYPE } from "constants/dbEnums";

const NearByPropertiesModal = ({ isOpen, onClose, data }) => {
  const { apiCall, loading } = useApi();
  const [requirementData, setRequirementData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(50);
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [confirmType, setConfirmType] = useState("");
  const [sendWhatsapp, setSendWhatsapp] = useState(false);
  const [whatsappMessage, setWhatsappMessage] = useState("");
  const [sendSMS, setSendSMS] = useState(false);

  const filterPayload = useMemo(() => {
    let {
      location,
      user_id,
      ad_type,
      property_type,
      shared_accommodation_interest,
    } = data || {};
    const { city, locality, sub_locality } = location || {};
    let collection_type;
    if (
      property_type === PROPERTY_COLLECTIONS.PLOT ||
      property_type === PROPERTY_COLLECTIONS.PG
    ) {
      collection_type = property_type;
      ad_type = "";
    } else if (shared_accommodation_interest) {
      collection_type = PROPERTY_COLLECTIONS.SHARE_FLAT;
      ad_type = "";
    } else {
      collection_type = PROPERTY_COLLECTIONS.RESIDENTIAL_PROPERTY;
    }
    return {
      city,
      locality,
      sub_locality,
      exclude_owner_id: user_id,
      ad_type,
      collection_type,
    };
  }, [data]);

  const [filter, setFilter] = useState(filterPayload);

  const getNearByProperties = useCallback(
    async (page = 1) => {
      try {
        const res = await apiCall.get(GET_RECOMMENDED_PROPERTIES, {
          ...filter,
          page,
          limit: 50,
        });
        if (res?.data?.data) {
          setRequirementData(res?.data?.data || []);
          setTotalCount(res?.data?.count || 0);
        }
      } catch (error) {
        showToast({
          message: error.response?.data?.error?.message || error.message,
          success: false,
          customStyle: {
            background: "#ff4d4f",
            color: "#fff",
            padding: "10px",
          },
        });
      }
    },
    [limit, filter]
  );

  useEffect(() => {
    getNearByProperties(currentPage);
    setSelectedLeads([]);
  }, [currentPage, filter]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setSelectedLeads([]);
  };

  const handleCheckboxChange = (propertyObject) => {
    setSelectedLeads((prev) => {
      const existingIndex = prev.findIndex(
        (item) => item._id === propertyObject._id
      );
      if (existingIndex > -1) {
        // Remove if already selected
        return prev.filter((_, index) => index !== existingIndex);
      } else {
        // Add full object if not selected
        return [...prev, propertyObject];
      }
    });
  };

  const handleShareLead = useCallback(
    async (value = []) => {
      try {
        if (!value?.length) return;
        const properties = value.map(
          ({
            location,
            ad_type,
            property_type,
            sharing_type,
            _id,
            owner_id,
          }) => {
            return {
              city: location?.city,
              owner_id,
              ad_type: filter?.collection_type,
              ad_id: _id,
              type: ad_type || "",
              property_type: property_type || sharing_type || "",
            };
          }
        );
        const payload = { properties, user_id: data?.user_id };
        setIsConfirmOpen(false);
        await apiCall.post(SHARE_RECOMMENDED_PROPERTIES, payload);
      } catch (error) {
        showToast({
          message:
            error?.response?.data?.error?.message ||
            error?.message ||
            "Failed to Send Property",
          success: false,
          customStyle: {
            background: "#ff4d4f",
            color: "#fff",
            padding: "10px",
          },
        });
      }
    },
    [data, sendSMS, filter]
  );

  const handleSendSelectedLeads = async () => {
    await handleShareLead(selectedLeads);
    if (sendWhatsapp) {
      shareToWhatsApp(whatsappMessage, data?.user_data?.phone);
    }
    showToast({
      message: `${selectedLeads.length} Properties Sent Successfully!`,
      success: true,
    });
  };

  const handleSendAllLeads = async () => {
    // Add your logic to send all leads
    await handleShareLead(requirementData);
    if (sendWhatsapp) {
      shareToWhatsApp(whatsappMessage, data?.user_data?.phone);
    }
    showToast({
      message: `${requirementData.length} Properties Sent Successfully!`,
      success: true,
    });
  };

  const totalPages = Math.ceil(totalCount / limit);

  const openConfirmation = (type) => {
    setConfirmType(type);
    setIsConfirmOpen(true);
  };

  //   const getLeadsNames = () => {
  //     const hasSelected = selectedLeads.length;
  //     const firstItem = hasSelected
  //       ? requirementData.find((item) => item._id === selectedLeads[0])
  //       : requirementData?.[0];

  //     const firstName = firstItem?.user_data?.first_name || "";

  //     const remaining = hasSelected ? selectedLeads.length - 1 : totalCount - 1;

  //     return remaining > 0
  //       ? `${firstName} and ${remaining} others are`
  //       : `${firstName} is`;
  //   };

  const getCurrentMessage = useCallback(() => {
    const { user_data, location } = data || {};
    const { slug_url } = selectedLeads?.[0] || {};
    let propertyType;
    if (selectedLeads?.length === 1) {
      const { property_type, sharing_type, collection_type } =
        selectedLeads?.[0] || {};
      propertyType =
        PROPERTY_TYPE[sharing_type || property_type || collection_type] || "";
    } else {
      const { property_type, ad_type, shared_accommodation_interest } =
        data || {};
      propertyType = shared_accommodation_interest
        ? "Co-Living"
        : PROPERTY_TYPE[property_type] || ad_type || "";
    }
    const urlVal =
      selectedLeads?.length === 1
        ? `property-details/${slug_url}/`
        : "account/bookmark/";

    const template = whatsappMessageFormat["property_recommendation"];
    if (!template) return;

    const replacements = {
      "{{user}}": user_data?.first_name || "",
      "{{location}}": `${location?.locality ? `${location?.locality},` : ""} ${
        location.city
      }`,
      "{{slug_url}}": `${process.env.REACT_APP_HEXAHOME_BASE_URL}/${urlVal}`,
      "{{property_type}}": propertyType,
    };

    const messageFormatted = Object.entries(replacements).reduce(
      (msg, [placeholder, value]) => msg.replace(placeholder, value),
      template
    );
    setWhatsappMessage(messageFormatted);
  }, [data, selectedLeads]);

  const handleCollectionTypeChange = useCallback((e) => {
    const val = e.target?.value?.value;
    if (!val) return;
    setFilter((prev) => ({ ...prev, collection_type: val }));
  }, []);

  const options = useMemo(() => {
    let opts = [];
    switch (filterPayload.collection_type) {
      case PROPERTY_COLLECTIONS.PLOT:
        opts = [
          {
            id: PROPERTY_COLLECTIONS.PLOT,
            name: "Plot",
            value: PROPERTY_COLLECTIONS.PLOT,
          },
        ];
        break;
      case PROPERTY_COLLECTIONS.PG:
      case PROPERTY_COLLECTIONS.SHARE_FLAT:
        opts = [
          {
            id: PROPERTY_COLLECTIONS.PG,
            name: "PG",
            value: PROPERTY_COLLECTIONS.PG,
          },
          {
            id: PROPERTY_COLLECTIONS.SHARE_FLAT,
            name: "Shared Accommodation",
            value: PROPERTY_COLLECTIONS.SHARE_FLAT,
          },
        ];
        break;
      case PROPERTY_COLLECTIONS.RESIDENTIAL_PROPERTY:
      case PROPERTY_COLLECTIONS.COMMERCIAL_PROPERTY:
        opts = [
          {
            id: PROPERTY_COLLECTIONS.RESIDENTIAL_PROPERTY,
            name: "Residential Property",
            value: PROPERTY_COLLECTIONS.RESIDENTIAL_PROPERTY,
          },
          {
            id: PROPERTY_COLLECTIONS.COMMERCIAL_PROPERTY,
            name: "Commercial Property",
            value: PROPERTY_COLLECTIONS.COMMERCIAL_PROPERTY,
          },
        ];
        break;
    }
    return opts;
  }, [filterPayload.collection_type]);

  if (loading) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Flex
              width={"100%"}
              height={"400px"}
              align={"center"}
              justify={"center"}
            >
              <Spinner size="lg" color="#22acee" thickness="6px" />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    );
  }

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="full">
        <ModalOverlay />
        <ModalContent>
          <ModalBody p={6}>
            <Flex direction={"column"} gap={4} width={"full"}>
              {/* Header with Close Button and Actions */}
              <Box
                position="sticky"
                top="0"
                zIndex="10"
                bg="white"
                pb={3}
                pt={2}
                borderBottom="1px solid"
                borderColor="gray.200"
              >
                <Flex
                  justify="space-between"
                  align="center"
                  flexWrap="wrap"
                  gap={4}
                >
                  {/* LEFT SIDE - Title, Count & Select */}
                  <Flex
                    direction={{ base: "column", md: "row" }}
                    align={{ base: "flex-start", md: "center" }}
                    gap={4}
                  >
                    <Box>
                      <Text fontSize="2xl" fontWeight="bold" lineHeight="1.2">
                        Nearby Properties
                      </Text>
                      <Text fontSize="md" color="gray.600">
                        Total: {totalCount}{" "}
                        {totalCount === 1 ? "Property" : "Properties"}
                      </Text>
                    </Box>
                    <Box width={"100"}>
                      <SelectInput
                        name="collection_type"
                        selectedValue={filter.collection_type}
                        options={options}
                        onChange={handleCollectionTypeChange}
                      />
                    </Box>
                  </Flex>

                  {/* RIGHT SIDE - Owner Info */}
                  <Flex
                    direction="column"
                    align={{ base: "flex-start", md: "flex-end" }}
                    flex="1"
                  >
                    <Text fontSize="md" color="gray.700" fontWeight="semibold">
                      User:{" "}
                      {data?.user_data?.full_name
                        ? data.user_data.full_name
                        : "N/A"}{" "}
                      ({data?.user_data?.classified_primary_role || "N/A"})
                    </Text>
                    <Text fontSize="md" color="gray.600">
                      📞 {data?.user_data?.phone || "N/A"}
                    </Text>
                  </Flex>

                  {/* ACTION BUTTONS */}
                  <HStack spacing={3}>
                    {/* REFRESH BUTTON */}
                    <IconButton
                      icon={<RepeatIcon />}
                      aria-label="Refresh properties"
                      variant="outline"
                      onClick={() => {
                        getNearByProperties(currentPage);
                        setSelectedLeads([]);
                      }}
                    />

                    {requirementData?.length ? (
                      <Button
                        colorScheme="blue"
                        size="md"
                        onClick={() => openConfirmation("all")}
                      >
                        Send All
                      </Button>
                    ) : null}

                    {selectedLeads.length > 0 && (
                      <Button
                        colorScheme="green"
                        size="md"
                        onClick={() => openConfirmation("selected")}
                      >
                        Send Selected ({selectedLeads.length})
                      </Button>
                    )}

                    <Button
                      variant="outline"
                      borderRadius="full"
                      onClick={onClose}
                      size="sm"
                    >
                      ✕
                    </Button>
                  </HStack>
                </Flex>
              </Box>

              {/* Requirements List */}
              <VStack spacing={3} align="stretch" minH="500px">
                {requirementData.length === 0 ? (
                  <Flex
                    justify="center"
                    align="center"
                    minH="400px"
                    direction="column"
                    gap={2}
                  >
                    <Text fontSize="lg" color="gray.500">
                      No Properties Found
                    </Text>
                  </Flex>
                ) : (
                  <Box overflowX="auto">
                    <Table variant="simple" size="sm">
                      <Thead bg="gray.50" position="sticky" top={0} zIndex={1}>
                        <Tr>
                          <Th width="50px" textAlign="center">
                            <Checkbox
                              isChecked={
                                selectedLeads.length ===
                                  requirementData.length &&
                                requirementData.length > 0
                              }
                              isIndeterminate={
                                selectedLeads.length > 0 &&
                                selectedLeads.length < requirementData.length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedLeads([...requirementData]);
                                } else {
                                  setSelectedLeads([]);
                                }
                              }}
                              colorScheme="blue"
                            />
                          </Th>
                          <Th minW="220px">Slug Url</Th>
                          <Th minW="200px">Owner</Th>
                          <Th minW="160px">Property Type</Th>
                          <Th minW="120px">Featured</Th>
                          <Th minW="120px">Distance</Th>
                          <Th minW="140px">Posted On</Th>
                          <Th minW="140px">Sent On</Th>
                          <Th minW="180px">Sent By</Th>
                          <Th minW="120px" textAlign="center">
                            Status
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {requirementData.map((req) => (
                          <Tr
                            key={req._id}
                            _hover={{ bg: "blue.50" }}
                            transition="all 0.2s"
                          >
                            {/* Checkbox */}
                            <Td textAlign="center">
                              <Checkbox
                                isChecked={selectedLeads.some(
                                  (item) => item._id === req._id
                                )}
                                onChange={() => handleCheckboxChange(req)}
                                colorScheme="blue"
                              />
                            </Td>

                            {/* User Info */}
                            <Td>
                              <VStack align="flex-start" spacing={0}>
                                <Link
                                  href={`${process.env.REACT_APP_HEXAHOME_BASE_URL}/property-details/${req.slug_url}/`}
                                  isExternal={false}
                                  target="_blank"
                                >
                                  <Text fontSize="xs" color="gray.600">
                                    {req.slug_url}
                                  </Text>
                                </Link>
                              </VStack>
                            </Td>

                            {/* Property Type */}
                            <Td>
                              <Link
                                href={`/#/admin/users?search_text=${req.owner_data?.phone}`}
                                isExternal={false}
                                target="_blank"
                              >
                                <Text fontSize="xs" color="gray.600">
                                  {req.owner_data?.name} (
                                  {req.owner_data?.phone})
                                </Text>
                              </Link>
                            </Td>

                            {/* Ad Type */}
                            <Td>
                              <Text fontSize="xs" color="gray.600">
                                {req.property_type ||
                                  req.sharing_type ||
                                  filterPayload.collection_type}
                              </Text>
                            </Td>
                            <Td>
                              {req.featured ? (
                                <Badge
                                  colorScheme={"blue"}
                                  textTransform="capitalize"
                                >
                                  FEATURED
                                </Badge>
                              ) : (
                                "-"
                              )}
                            </Td>

                            {/* Location */}
                            <Td>
                              <HStack spacing={1}>
                                <Text fontSize="sm" fontWeight="bold">
                                  📍{metersToKm(req.distance)} km
                                </Text>
                              </HStack>
                            </Td>

                            {/* Created Date */}
                            <Td>
                              <Text fontSize="xs" color="gray.600">
                                {formatDate(req.created_at)}
                              </Text>
                            </Td>

                            <Td>
                              <Text fontSize="xs" color="gray.600">
                                {req.lead_details?.created_at
                                  ? formatDate(req.lead_details?.created_at)
                                  : "-"}
                              </Text>
                            </Td>

                            <Td>
                              {req.lead_details?.sent_by?.phone ? (
                                <Link
                                  href={`/#/admin/users?search_text=${req.owner_data?.phone}`}
                                  isExternal={false}
                                  target="_blank"
                                >
                                  <Text fontSize="xs" color="gray.600">
                                    {req.lead_details?.sent_by?.name} (
                                    {req.lead_details?.sent_by?.phone})
                                  </Text>
                                </Link>
                              ) : (
                                <Text fontSize="xs" color="gray.600">
                                  -
                                </Text>
                              )}
                            </Td>

                            {/* Status */}
                            <Td>
                              <VStack spacing={1} align="center">
                                {req?.is_sent ? (
                                  <Badge
                                    bg={"blue.500"}
                                    color={"white"}
                                    fontSize="xs"
                                    minW="50px"
                                    textAlign="center"
                                    borderRadius="full"
                                    px={2}
                                    py={1}
                                  >
                                    Shared
                                  </Badge>
                                ) : null}
                              </VStack>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </Box>
                )}
              </VStack>

              {/* Pagination */}
              {totalPages > 1 && (
                <>
                  <Divider />
                  <Flex justify="center" align="center" gap={4}>
                    <IconButton
                      icon={<ChevronLeftIcon />}
                      onClick={() => handlePageChange(currentPage - 1)}
                      isDisabled={currentPage === 1}
                      size="sm"
                      aria-label="Previous page"
                    />
                    <Text fontSize="sm">
                      Page {currentPage} of {totalPages}
                    </Text>
                    <IconButton
                      icon={<ChevronRightIcon />}
                      onClick={() => handlePageChange(currentPage + 1)}
                      isDisabled={currentPage === totalPages}
                      size="sm"
                      aria-label="Next page"
                    />
                  </Flex>
                </>
              )}
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
      <Modal
        isOpen={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        isCentered
      >
        <ModalOverlay />
        <ModalContent size="xl">
          <ModalBody p={6} textAlign="center">
            <Flex justifyContent={"space-between"} alignItems={"center"}>
              <Text fontSize="lg" fontWeight="bold" mb={4}>
                {confirmType === "all"
                  ? `Send all ${totalCount} Properties?`
                  : `Send ${selectedLeads.length} Properties?`}
              </Text>
              <Flex gap={"0.5rem"}>
                <Checkbox
                  isChecked={sendSMS}
                  onChange={(e) => {
                    setSendSMS(e.target.checked);
                  }}
                >
                  Send SMS
                </Checkbox>
                <Checkbox
                  isChecked={sendWhatsapp}
                  onChange={(e) => {
                    setSendWhatsapp(e.target.checked);
                    getCurrentMessage();
                  }}
                >
                  Whatsapp
                </Checkbox>
              </Flex>
            </Flex>

            <Text fontSize="sm" color="gray.600" mb={6}>
              This action will send Property details to the respective users.
              Are you sure you want to proceed?
            </Text>

            {sendWhatsapp && (
              <Flex gap={2} direction={"column"}>
                <Textarea
                  value={whatsappMessage}
                  onChange={(e) => setWhatsappMessage(e.target.value)}
                  minHeight={250}
                />
              </Flex>
            )}

            <Flex justify="center" gap={4}>
              <Button
                colorScheme="blue"
                onClick={() => {
                  if (confirmType === "all") {
                    handleSendAllLeads();
                  } else {
                    handleSendSelectedLeads();
                  }
                }}
              >
                Yes, Send
              </Button>
              <Button variant="outline" onClick={() => setIsConfirmOpen(false)}>
                Cancel
              </Button>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default memo(NearByPropertiesModal);
